import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const list = () => import('./List.vue')
const details = () => import('./details/Details.vue')
const productsList = () => import('./products/List.vue')
// Page names
export const MOTIVATIONS_LIST_PAGE_NAME = 'cabinet:motivations'
export const MOTIVATION_DETAILS_PAGE_NAME = 'cabinet:motivation-details'
export const MOTIVATION_CREATE_PAGE_NAME = 'cabinet:motivation-create'
export const MOTIVATION_UPDATE_PAGE_NAME = 'cabinet:motivation-update'

export const MOTIVATIONS_PRODUCTS_ADD_PAGE_NAME = 'cabinet:products-add'

// URLs
export const MOTIVATIONS_LIST_PAGE_URL = ''
export const MOTIVATION_DETAILS_PAGE_URL = 'details/:id/'
export const MOTIVATION_CREATE_PAGE_URL = 'create/'
export const MOTIVATION_UPDATE_PAGE_URL = 'update/:id/'

export const MOTIVATIONS_PRODUCTS_ADD_PAGE_URL = 'update/:id/add-products/'

export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(MOTIVATIONS_PRODUCTS_ADD_PAGE_URL, productsList, MOTIVATIONS_PRODUCTS_ADD_PAGE_NAME, {
      meta: {
        breadcrumb: 'motivations-products-add',
        parent: MOTIVATION_UPDATE_PAGE_NAME,
        // ...accessPermission([VIEW], options),
      }
    }),
    route(MOTIVATIONS_LIST_PAGE_URL, list, MOTIVATIONS_LIST_PAGE_NAME, {
      meta: {
        breadcrumb: 'motivations',
        // ...accessPermission([VIEW], options),
      }
    }),
    route(MOTIVATION_DETAILS_PAGE_URL, details, MOTIVATION_DETAILS_PAGE_NAME, {
      meta: {
        breadcrumb: 'motivation',
        parent: MOTIVATIONS_LIST_PAGE_NAME,
        // ...accessPermission([VIEW], options),
      }
    }),
    route(MOTIVATION_CREATE_PAGE_URL, details, MOTIVATION_CREATE_PAGE_NAME, {
      meta: {
        breadcrumb: 'motivation-create',
        parent: MOTIVATIONS_LIST_PAGE_NAME,
        isNew: true,
        // ...accessPermission([VIEW], options),
      }
    }),
    route(MOTIVATION_UPDATE_PAGE_URL, details, MOTIVATION_UPDATE_PAGE_NAME, {
      meta: {
        breadcrumb: 'motivation-update',
        parent: MOTIVATIONS_LIST_PAGE_NAME,
        isUpdate: true,
        isNew: false,
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
